module.exports = __webpack_public_path__ + "static/media/left-arrow.c78476b1.svg";